<template>
    <v-container fluid class="ma-4">
      <TradingTrialsStats class="mb-3" />
        <v-data-table-server
                v-model:items-per-page="itemsPerPage"
                :search="search"
                :headers="headers"
                :items-length="totalItems"
                :items="serverItems"
                :loading="loading"
                class="elevation-1 pa-4"
                @update:itemsPerPage="changeItemsPrePage"
                @update:page="loadItemsPage"
                @update:sortBy="loadSortPage"
                @update:modelValue="loadItems"
        >
            <template v-slot:top>
                <v-row>
                    <v-col>
                        <v-text-field
                                v-model="search.id"
                                  variant="outlined"
                                  hide-details
                                  type="number"
                                  placeholder="Search id..."
                                  class="ma-1"
                                  @input="loadItems"
                                  density="compact"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                                v-model="search.first_name"
                                hide-details
                                variant="outlined"
                                placeholder="Search name..."
                                class="ma-1"
                                density="compact"
                                @input="loadItems"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                                v-model="search.referrer_id"
                                variant="outlined"
                                hide-details
                                type="number"
                                placeholder="ID куратора..."
                                class="ma-1"
                                density="compact"
                                @input="loadItems"
                        ></v-text-field>
                    </v-col>
                  <v-col>
                    <v-select
                        v-model="search.user_has_active_pricing_plan"
                        hide-details
                        variant="outlined"
                        :items="userHasActivePricingPlan"
                        return-object
                        placeholder="Активный тариф..."
                        class="ma-1"
                        item-text="title"
                        density="compact"
                        @update:modelValue="loadItems"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-select
                        v-model="search.user_has_pricing_plan"
                        hide-details
                        variant="outlined"
                        :items="userHasPricingPlan"
                        return-object
                        placeholder="С циклами..."
                        class="ma-1"
                        item-text="title"
                        density="compact"
                        @update:modelValue="loadItems"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-select
                        v-model="search.user_has_trading_cycles_ended_during_trial"
                        hide-details
                        variant="outlined"
                        :items="userHasTradingCyclesEndedDuringTrial"
                        return-object
                        placeholder="Купили тариф..."
                        class="ma-1"
                        item-text="title"
                        density="compact"
                        @update:modelValue="loadItems"
                    ></v-select>
                  </v-col>
                  <v-col class="reset">
                    <v-btn
                        prepend-icon="mdi-reload"
                        density="comfortable"
                        variant="text"
                        size="small"
                        @click="reset"
                    >
                      Сброс
                    </v-btn>
                    </v-col>
                    <v-col>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`item.user.id`]="{ item }">
                <router-link :to="`/users?id=${item.selectable.user.id}`">{{ item.selectable.user.id }}</router-link>
            </template>
            <template v-slot:[`item.user.first_name`]="{ item }">
                <router-link :to="`/users?name=${item.selectable.user.first_name}`">{{ item.selectable.user.first_name }}</router-link>
            </template>
            <template v-slot:[`item.user.last_name`]="{ item }">
                <router-link :to="`/users?name=${item.selectable.user.last_name}`">{{ item.selectable.user.last_name }}</router-link>
            </template>
            <template v-slot:[`item.started_at`]="{ item }">
                {{ moment(item.selectable.started_at * 1000).format('DD.MM.YYYY') }} {{ moment(item.selectable.started_at * 1000).format('HH:mm') }}
            </template>
            <template v-slot:[`item.user.expires_at`]="{ item }">
                {{ moment(item.selectable.expires_at * 1000).format('DD.MM.YYYY') }} {{ moment(item.selectable.expires_at * 1000).format('HH:mm') }}
            </template>
            <template v-slot:[`item.user.last_api_activity_at`]="{ item }">
              {{ item.selectable.user?.last_api_activity_at ? moment(item.selectable.user.last_api_activity_at * 1000).format('DD.MM.YYYY HH:mm:ss', true) : (item.selectable.last_api_activity_at ? moment(item.selectable.last_api_activity_at * 1000).format('DD.MM.YYYY HH:mm:ss', true) : '-') }}
            </template>
            <template v-slot:[`item.user.user_pricing_plan.title`]="{ item }">
                {{ item.selectable.user_pricing_plan?.title || '-' }}
            </template>
          <template v-slot:[`item.user.trading_cycles_ended_count`]="{ item }">
            {{ item.selectable.trading_cycles_ended_count ?? '-' }}
          </template>
          <template v-slot:[`item.user.lessons_passed`]="{ item }">
            {{ item.selectable.user?.lessons_passed ?? item.selectable.lessons_passed }} / {{ item.selectable.user?.lessons_total ?? item.selectable.lessons_total }}
          </template>
          <template v-slot:[`item.user.referrer.id`]="{ item }">
            {{ item.selectable.referrer.id ?? '-' }}
          </template>
          <template v-slot:[`item.curator`]="{ item }">
            <router-link v-if="item.selectable.referrer?.id" :to="`/users?id=${item.selectable.referrer.id}`">
              {{ item.selectable.referrer.first_name || '' }} {{ item.selectable.referrer.last_name || '' }}
            </router-link>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.user.total_binary_member_nodes_under_user`]="{ item }">
            {{ item.selectable.total_binary_member_nodes_under_user ?? '-' }}
          </template>
          <template v-slot:[`item.user.is_trading_enabled`]="{ item }">
            {{ (item.selectable.user?.is_trading_enabled ?? item.selectable.is_trading_enabled) ? 'Да' : 'Нет' }} {{ (item.selectable.user?.trading_block_reason ?? item.selectable.trading_block_reason) ? '(' + (item.selectable.user?.trading_block_reason ?? item.selectable.trading_block_reason) + ')' : '' }}
          </template>
          <template v-slot:[`item.user.telegram_profile`]="{ item }">
            <div v-if="item.selectable.user?.telegram_profile?.username || item.selectable.telegram_profile?.username">
              <a :href="`https://t.me/${item.selectable.user?.telegram_profile?.username || item.selectable.telegram_profile?.username}`" target="_blank">@{{ item.selectable.user?.telegram_profile?.username || item.selectable.telegram_profile?.username }}</a>
            </div>
            <div v-else-if="item.selectable.user?.telegram_profile?.id || item.selectable.telegram_profile?.id">
              {{ item.selectable.user?.telegram_profile?.id || item.selectable.telegram_profile?.id }}
            </div>
            <div v-else>-</div>
          </template>
        </v-data-table-server>
    </v-container>
</template>
<script>
import {getTradingTrials} from "../plugins/api-service";
import moment from 'moment';
import currencyFormatter from "../mixins/currencyFormatter";
import TradingTrialsStats from "../components/TradingTrialsStats.vue";

  export default {
    name: 'TradingTrials',
    components: {TradingTrialsStats},
    mixins: [currencyFormatter],
    data: () => ({
      itemsPerPage: 15,
      headers: [
        { title: 'ID', align: 'start', key: 'user.id' },
        { title: 'Имя', key: 'user.first_name', align: 'start', sortable: false },
        { title: 'Фамилия', key: 'user.last_name', align: 'start', sortable: false },
        { title: 'Дата начала триала', key: 'started_at', align: 'start' },
        { title: 'Дата конца триала', key: 'user.expires_at', align: 'start' },
        { title: 'Last seen', key: 'user.last_api_activity_at', align: 'start', sortable: false },
        { title: 'Текущий тариф пользователя', key: 'user.user_pricing_plan.title', align: 'start' },
        { title: 'Завершенных циклов', key: 'user.trading_cycles_ended_count', align: 'start' },
        { title: 'Уроков завершено', key: 'user.lessons_passed', align: 'start', sortable: false },
        { title: 'ReferrerID', key: 'user.referrer.id', align: 'start' },
        { title: 'Куратор', key: 'curator', align: 'start', sortable: false },
        { title: 'Бинар', key: 'user.total_binary_member_nodes_under_user', align: 'start' },
        { title: 'Торговля разрешена', key: 'user.is_trading_enabled', align: 'start', sortable: false },
        { title: 'Телеграм', key: 'user.telegram_profile', align: 'start', sortable: false },
      ],
      serverItems: [],
      loading: true,
      totalItems: 0,
      search: {
        id: null,
        first_name: '',
        referrer_id: null,
        user_has_active_pricing_plan: null,
        user_has_pricing_plan: null,
        user_has_trading_cycles_ended_during_trial: null,
      },
      sort: {},
      userHasActivePricingPlan: [
          {
            title: 'Есть',
            value: 1,
          },
        {
          title: 'Нет',
          value: 0,
        }
          ],
      userHasPricingPlan: [
        {
          title: 'Да',
          value: 1,
        },
        {
          title: 'Нет',
          value: 0,
        }
      ],
      userHasTradingCyclesEndedDuringTrial: [
        {
          title: 'Да',
          value: 1,
        },
        {
          title: 'Нет',
          value: 0,
        }
      ]
    }),
    mounted() {
      this.loadItems()
    },
    methods: {
      moment,
      async loadItemsPage(page) {
        this.loadItems({
          page,
          order_by: this.sort.order_by,
          order_direction: this.sort.order_direction
        });
      },
      async loadSortPage(params) {
        let requestParams = {};
        if(params && params.length && params[0]['key'] && params[0]['key']) {
          requestParams.order_by = params[0].key;
          requestParams.order_direction = params[0].order;
        }

        this.sort = requestParams;

        this.loadItems(requestParams);
      },
      async loadItems(params) {
        this.loading = true;

        let page = params?.page || 1;
        let itemsPerPage = params?.itemsPerPage || (this.itemsPerPage > 0 ? this.itemsPerPage : this.totalItems);

        let requestParams = {
          offset: (page - 1) * itemsPerPage,
          limit: page === -1 ? this.totalItems : itemsPerPage,
          user_id: this.search.id || this.$route.params.id
        };

        if(this.search.first_name) {
          requestParams.user_name_contains = this.search.first_name;
        }

        if(this.search.referrer_id) {
          requestParams.referrer_id = this.search.referrer_id;
        }

        if(this.search.user_has_active_pricing_plan) {
          requestParams.user_has_active_pricing_plan = this.search.user_has_active_pricing_plan.value;
        }

        if(this.sort.order_direction && this.sort.order_by) {
          requestParams.order_by = params.order_by;
          requestParams.order_direction = params.order_direction;
        }

        if(params?.order_direction && params?.order_by) {
          requestParams.order_by = params.order_by;
          requestParams.order_direction = params.order_direction;
        }

        if(this.search.user_has_pricing_plan?.value) {
          requestParams.user_has_pricing_plan = !!this.search.user_has_pricing_plan.value;
        }
        if(this.search.user_has_trading_cycles_ended_during_trial?.value) {
          requestParams.user_has_trading_cycles_ended_during_trial = !!this.search.user_has_trading_cycles_ended_during_trial.value;
        }


        await getTradingTrials(requestParams).then(response=>{
          if(response?.success) {
            this.serverItems = response.result.items;
            this.totalItems = response.result.total;
            this.loading = false;
          }
        });
      },
      reset() {
        this.search = {...{
            id: null,
            first_name: '',
            referrer_id: null,
            user_has_active_pricing_plan: null,
            user_has_pricing_plan: null,
            user_has_trading_cycles_ended_during_trial: null,
          }};

        this.$router.push('/trading-trials');
        this.loadItems();
      },
    },
  }
</script>
<style lang="scss" scoped>
    .adm-container {
        min-height: calc(100vh - 64px);
    }
    .reset {
      display: flex;
      align-items: center;
    }
</style>